import { useCallback } from 'react';

import { useAssetModalVersionsPanel } from '~/components/AssetModalV2/AssetModalPanelsContextProvider';

export const useVersionsPanelToggle = () => {
  const { isVersionsPanelOpen, openVersionsPanel, closeVersionsPanel } = useAssetModalVersionsPanel();

  const toggleVersionsPanel = useCallback(() => {
    if (isVersionsPanelOpen) {
      closeVersionsPanel();
      return;
    }

    openVersionsPanel();
  }, [closeVersionsPanel, isVersionsPanelOpen, openVersionsPanel]);

  return { isVersionsPanelOpen, toggleVersionsPanel };
};
